import { FunctionComponent, useEffect, useState } from 'react';
import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import ScrollMagicFn from '@/utils/ScrollMagic';
import EFVideo from '@/components/UI/EFVideo';

interface PropsType {
    id: string;
}
const AppKit: FunctionComponent<PropsType> = (props) => {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();

    // 动画
    let ScrollMagic: any;
    let controller: any;
    if (typeof window !== 'undefined') {
        ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }
    useEffect(() => {
        controller = new ScrollMagic.Controller();
        return () => {
            (ScrollMagic = null), (controller = null);
        };
    }, []);

    const [smartEnter, setSmartEnter] = useState<boolean>(false);

    useEffect(() => {
        const origin = '.scroll-trigger-origin-H';
        const scene = new ScrollMagic.Scene({ triggerElement: origin, triggerHook: 'onLeave', offset: -60 });
        scene.on('enter', () => setSmartEnter(true));
        scene.on('leave', () => setSmartEnter(false));
        controller.addScene(scene);
    }, []);

    return (
        <div className={css.appKit} id={props.id}>
            <div className="content">
                <div className="inner_first">
                    <div className="uninterrupted-power scroll-trigger-origin-H">
                        <div className={`text-box-wrap content-video-text ${smartEnter ? 'to' : 'from'}`}>
                            <div className={`text-box`}>
                                <div className={`text-box-video ${smartEnter ? 'toLocation' : ''}`}>
                                    <div className="title">{t('secH_title_h5')}</div>
                                    <div className="text">{t('secH_desc')}</div>
                                </div>
                            </div>
                        </div>
                        <div className="video-box">
                            {['sa', 'za', 'au'].includes(locale) && (
                                <EFVideo
                                    className="video-box"
                                    sources={['/video/landingPage/h5/dp2.mp4', '/video/landingPage/h5/dp2.mp4']}
                                    poster="/video/landingPage/h5/dp.png"
                                    autoPlay
                                />
                            )}
                            {!['sa', 'za', 'au'].includes(locale) && (
                                <EFVideo
                                    className="video-box"
                                    sources={['/video/landingPage/h5/dp.webm', '/video/landingPage/h5/dp.mp4']}
                                    poster="/video/landingPage/h5/dp.png"
                                    autoPlay
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default AppKit;
